import { strapiAxios } from '../strapiAxios';
import { capture } from '../../services/sentry/capture';
import AxiosError from '../../helpers/errors/axios.error';
import { UpdateCommandeParams } from '../../types/commande/formatUpdateCommande';
import toast from 'react-hot-toast';

export const updateCommande = async (commande: UpdateCommandeParams) => {
  try {
    await strapiAxios.put('commandes/' + commande.id, commande);
    toast.success('La commande a bien été mise à jour');
    setTimeout(() => window.location.reload(), 800);
  } catch (e) {
    capture(new AxiosError('update commande', e));
    toast.error(
      e?.response?.data?.message ||
        'Problème lors de la modification de la commande'
    );
    setTimeout(() => window.location.reload(), 800);
  }
};
